import React, { useContext } from 'react'
import styled from 'styled-components'
import PickPackLogo from '../../images/Logo_Standard.png'
import { HeaderSmall } from '../Text'
import { isBrowser } from '../../utils/window'
import { SessionContext } from '../../providers/SessionContextProvider'

const Container = styled.a`
  display: flex;
  align-items: center;
`

const Prefix = styled(HeaderSmall)`
  margin-right: 0.3rem;
  white-space: pre;
  font-weight: bold;
`

const Logo = styled.img`
  height: 0.8rem;
  width: auto;
`

// const DeepLinkToHP = 'https://www.pickpack.de/?_branch_match_id=573938642546313686'
const STORE_LINK = 'https://link.pickpack.de/store?id='

// eslint-disable-next-line react/prop-types
function PoweredBy() {
  const { store } = useContext(SessionContext)
  const visible = isBrowser && window.location.hostname !== 'web.pickpack.de'
  return visible && store ? (
    <Container href={`${STORE_LINK}${store.id}`} target="_blank">
      <Prefix>powered by</Prefix>
      <Logo src={PickPackLogo} />
    </Container>
  ) : null
}

export default PoweredBy
